import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDevDotToComponent } from './simple-icons-dev-dot-to.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDevDotToComponent ],
    exports:      [ SimpleIconsDevDotToComponent ],
    bootstrap:    []
})
export class SimpleIconsDevDotToModule {}
